"use client"

import Image from "next/image"
import Link from "next/link"
import { useEffect, useState } from "react"

function useHelpUrl() {
  const [url, setUrl] = useState("#")
  useEffect(() => {
    if (typeof window === "undefined") return
    const host = window.location.host.replace(/^help\./, "")
    setUrl(`${window.location.protocol}//help.${host}`)
  }, [])
  return url
}

const COLUMNS: { title: string; items: { label: string; href: string; external?: boolean }[] }[] = [
  {
    title: "Документы",
    items: [
      { label: "Публичная оферта", href: "/offer" },
      { label: "Правила сервиса", href: "/terms" },
      { label: "Политика конфиденциальности", href: "/privacy" },
    ],
  },
  {
    title: "Ресурсы",
    items: [
      { label: "Блог", href: "/blog" },
      { label: "Инструкции", href: "__HELP__", external: true },
    ],
  },
  {
    title: "Компания",
    items: [
      { label: "О нас", href: "/about" },
      { label: "Контакты", href: "/#contact" },
    ],
  },
]

const LABEL =
  "font-mono text-[11px] uppercase tracking-[0.12em] text-[rgba(11,16,32,0.55)]"

export function Footer() {
  const currentYear = new Date().getFullYear()
  const helpUrl = useHelpUrl()

  return (
    <footer className="bg-white text-[#0b1020] text-[13px]">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-14 pt-12 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1fr] gap-8 pb-8 border-b border-[rgba(11,16,32,0.10)]">
          <div>
            <div className="mb-4">
              <Image
                src="/brand/mark-only.svg"
                alt="МЕТКА"
                width={180}
                height={60}
                priority={false}
                style={{ height: "auto", width: 180 }}
              />
            </div>
            <p className="max-w-[320px] leading-[1.5] text-[rgba(11,16,32,0.70)]">
              Маркировка интернет-рекламы и отчётность в ЕРИР для рекламодателей, агентств и блогеров.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://t.me/metka_support_bot"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 border border-[rgba(11,16,32,0.10)] hover:border-[rgba(11,16,32,0.30)] flex items-center justify-center transition-colors rounded-[4px]"
                aria-label="Telegram"
              >
                <svg className="w-4 h-4 text-[#0b1020]/80" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z" />
                </svg>
              </a>
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <div className={`${LABEL} mb-3`}>{col.title}</div>
              <ul className="flex flex-col gap-2">
                {col.items.map((item) => (
                  <li key={item.label}>
                    {item.external ? (
                      <a
                        href={item.href === "__HELP__" ? helpUrl : item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#0b1020]/80 hover:text-[#0b1020] transition-colors"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        href={item.href}
                        className="text-[#0b1020]/80 hover:text-[#0b1020] transition-colors"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-5 flex flex-col md:flex-row md:justify-between gap-3 text-[12px] text-[rgba(11,16,32,0.55)]">
          <div>© {currentYear} МЕТКА. Все права защищены.</div>
          <div>ИП Константинова Ю.Е. · ИНН 780250720139 · ОГРНИП 323784700336436</div>
        </div>
      </div>
    </footer>
  )
}
